import { useCallback } from 'react';
import { useRouter } from '@funtech-int/rival-react';

import { playingContentIdVar } from '../hooks/use-playing-content-id-var';

import { cleanQueryParamsOnStopPlayingContent } from './clean-query-params-on-stop-playing-content';

export const useStopPlayingContent = () => {
    const router = useRouter();

    const stopPlayingContent = useCallback(() => {
        cleanQueryParamsOnStopPlayingContent(router);

        playingContentIdVar.set(null);
    }, [router]);

    return stopPlayingContent;
};
